import {
  SET_SELECTED_INSTITUTE_IDS,
  SET_INSTITUTES,
  UPDATE_INSTITUTE,
  ADD_INSTITUTE,
  DELETE_INSTITUTE,
  InstituteActionTypes,
  Institute,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

/** Not in use */
export const setSelectedInstituteIds = (payload: number[] | string[]): InstituteActionTypes => ({
  type: SET_SELECTED_INSTITUTE_IDS,
  payload,
});

export const setInstitutes = (payload: Institute[]): InstituteActionTypes => ({
  type: SET_INSTITUTES,
  payload,
});

export const fetchInstitutes = (): AppThunk => async (dispatch): Promise<void> => {
  const institutes = await ApiClient.getInstitutes();
  dispatch(setInstitutes(institutes));
};

export const updateReduxInstitute = (payload: Institute): InstituteActionTypes => ({
  type: UPDATE_INSTITUTE,
  payload,
});

export const addReduxInstitute = (payload: Institute): InstituteActionTypes => ({
  type: ADD_INSTITUTE,
  payload,
});

export const deleteReduxInstitute = (instituteId: number): InstituteActionTypes => ({
  type: DELETE_INSTITUTE,
  payload: instituteId,
});

export const addInstitute = (institute: Institute): AppThunk => async (dispatch): Promise<void> => {
  const addedInstitute = await ApiClient.addInstitute(institute);
  dispatch(addReduxInstitute(addedInstitute));
};

export const deleteInstitute = (
  institute: Institute,
): AppThunk => async (dispatch): Promise<void> => {
  await ApiClient.deleteInstitute(institute);
  dispatch(deleteReduxInstitute(institute.id));
};

export const updateInstitute = (
  institute: Institute,
): AppThunk => async (dispatch): Promise<void> => {
  const updatedInstitute = await ApiClient.updateInstitute(institute);
  dispatch(updateReduxInstitute(updatedInstitute));
};

export const approveInstitutes = (
  instituteIds: number[],
): AppThunk => async (dispatch, getState): Promise<void> => {
  const state = getState();
  const instituteByIds = state.institute.byId;
  if (!instituteByIds) {
    return;
  }
  const updatedInstitutes = await ApiClient.approveInstitutes(instituteIds);
  updatedInstitutes.forEach((institute) => {
    dispatch(updateReduxInstitute(institute));
  });
};
